import { TextField } from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';
import { _IEditProps } from './_IEditProps';

function onFocus(event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) {
	event.target.select();
}

const readonlyInputProps = { readOnly: true, disabled: false, onFocus };
const readwriteInputProps = { readOnly: false, disabled: false, onFocus };
const inputLabelProps = { shrink: true };

function inputType(type: string) {
	switch (type) {
	case 'number':
	case 'int':
	case 'posInt':
	case 'nonNegInt':
		return 'number';
	}
	return 'text';
}

export const _StringEdit = observer(function _StringEdit(props: _IEditProps) {
	const {accessors, type, label, error, isRequired, isReadonly, className, variant, helperText, placeholder} = props;
	const value = accessors.getter();
	return <TextField
		className={className}
		type={inputType(type)}
		disabled={isReadonly}
		error={error}
		helperText={helperText}
		InputLabelProps={inputLabelProps}
		inputProps={isReadonly ? readonlyInputProps : readwriteInputProps}
		label={label}
		onChange={accessors.handleChange}
		required={isRequired}
		value={'' + value}
		variant={variant}
		placeholder={placeholder}
	/>;
});
